export default {
  TILE: 'tile',
};
